import { COLOR_PALETTE } from '../constants/color-palette';

export function injectCssVariables(): () => void {
  return () => {
    const root = document.documentElement;
    Object.entries(COLOR_PALETTE).forEach(([key, value]) => {
      root.style.setProperty(`--snk-color-${key}`, value);
    });
  };
}
